import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { Title } from 'components/Title';

export default function DebitpresentationPage() {
	
	const [pageReady, setPageReady] = useState(true);
	    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const formatDate = (d) => {
        if (!d) return "";
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const handleVerify = async () => {
        if (!dateFrom || !dateTo) {
            alert("Please select both dates");
            return;
        }
        setLoading(true);
        setResult(null);
        try {
            const response = await fetch(
            `${process.env.REACT_APP_API_PATH}kyc/send-request`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    FromDate: formatDate(dateFrom),
                    ToDate: formatDate(dateTo)
                }),
            }
            );
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();
            setResult(data.StatusMessage || "Verification completed");
            } catch (error) {
            console.error("Error verifying mandates:", error);
            setResult("Error: " +error.message);
            } finally {
            setLoading(false);
        }
    };
	return (
		<main id="DebitpresentationPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="DebitPresentation"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="p-4 max-w-md mx-auto bg-white shadow-lg rounded-lg">
                        <h2 className="text-xl font-bold mb-4">Debit Presentation by Date Range</h2>
                        <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                            <div className="">
                                <div className="">
                                    <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateFrom}
                                    onChange={(e) => setDateFrom(e.target.value)} placeholder={$t('Date From')}   />
                                </div>
                            </div>
                        </div>
                        <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                            <div className="">
                                <div className="">
                                    <Calendar showIcon={true} showButtonBar={true} dateFormat="yy-mm-dd" hourFormat="24" className="w-full" selectionMode="single" value={dateTo}
                                    onChange={(e) => setDateTo(e.target.value)} placeholder={$t('Date To')}   />
                                </div>
                            </div>
                        </div>
                        <div className="sm:col-3 lg:col-2 md:col-2 comp-grid" >
                            <div className="">
                                <button
                                onClick={handleVerify}
                                disabled={loading}
                                className="bg-green-600 text-white px-4 py-2 rounded w-full hover:bg-blue-700"
                                >
                                {loading ? "Verifying..." : "Debits Submit"}
                                </button>
                            </div>
                        </div>
                        {result && (
                        <div className="mt-4 text-center font-medium text-green-700">
                            {result}
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
